export default __webpack_public_path__ + "static/media/CircleArrow.2f81ee4b.svg";